import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { SvcAnalysisScreen } from "./SvcAnalysisScreen";
import { SvcSessionListScreen } from "./SvcSessionsList/SvcSessionListScreen";
import { SvcAnalysisSetListScreen } from "./AnalysisSetsList/SvcAnalysisSetListScreen";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { PrivateRoute } from "../../Core/PrivateRoute";

export const SvcRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/Svc" exact permissions={[PermissionEnum.AccessSingleSvcSession, PermissionEnum.AccessAllSvcSessions, PermissionEnum.OverreadSvcSession]}>
                <SvcSessionListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Svc/Analysis" exact permissions={[PermissionEnum.OverreadSvcSession]}>
                <SvcAnalysisSetListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Svc/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.AccessSingleSvcSession, PermissionEnum.OverreadSvcSession]}>
                <SvcAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
